import { render, staticRenderFns } from "./PluginScreenshots.vue?vue&type=template&id=6b129ee1"
import script from "./PluginScreenshots.vue?vue&type=script&lang=js"
export * from "./PluginScreenshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports